import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles, Lock } from "lucide-react";
import "./Billing.css";

export const formatNaira = (n) => `₦${Number(n || 0).toLocaleString("en-NG")}`;

/**
 * The note at the top of the course pages for people who have not subscribed.
 * `billing` comes from the courses API: { entitled, price_ngn }.
 */
export default function UpgradeBanner({ billing }) {
  const location = useLocation();
  if (!billing || billing.entitled) return null;

  const price = formatNaira(billing.price_ngn);
  const title = "The first topic of every subject is free";
  const text = `Subscribe for ${price} a month to unlock every other topic in every subject.`;

  const from = encodeURIComponent(location.pathname + location.search);
  return (
    <aside className="bl-banner" aria-label="Subscription">
      <span className="bl-banner-icon"><Sparkles size={20} aria-hidden="true" /></span>
      <div className="bl-banner-text">
        <strong>{title}</strong>
        <span>{text}</span>
      </div>
      <Link to={`/subscribe?from=${from}`} className="bl-btn bl-btn-gold">
        <Lock size={16} aria-hidden="true" /> Unlock everything
      </Link>
    </aside>
  );
}
